export default __webpack_public_path__ + "static/media/linkedin.b938cd94.svg";